<script>
  import options from './CardMediumPI.options'
  export default options
</script>

<template>
  <article class="nyk-card-medium nyk-card-medium-pi" :class="classNameColor">
      <div class="nyk-card-medium__header">
          <h3 class="nyk-card-medium__header__title">{{ title }}</h3>
      </div>

      <div class="nyk-card-medium__content">
          <p class="nyk-card-medium__content__description">{{ description }}</p>
      </div>

      <div class="nyk-card-medium__footer">
        <div class="nyk-card-medium-pi__dropdown">
            <select autocomplete="off" @change="onChange" ref="selectRef" class="nyk-card-medium-pi__dropdown__select" :aria-label="dropdownLabel">
                <option value="">{{ dropdownLabel }}</option>
                <option v-for="pi, index in piPartners" :key="index" :value="index">{{ pi.name }}</option>
            </select>
        </div>
      </div>
  </article>
</template>
